import $ from 'jquery';

const selector = '.js-filter-by-clinic';
const filter = $(selector);
const submitFiltersForm = (event) => {
    $(event.target)
        .closest(selector)
        .submit();
};

filter.find('select').on('change', submitFiltersForm);
filter.find('.switch').on('change', submitFiltersForm);
